import script from "./ProcedureNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcedureNotification.vue?vue&type=script&setup=true&lang=js"

import "./ProcedureNotification.vue?vue&type=style&index=0&id=c723e03c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c723e03c"]])

export default __exports__